import React from 'react';
import AppLinks from '../components/display/AppLinks';

function Contact() {
  return (
    <div className="container-xxl py-4 text-start">
      {/* Contact Banner */}
      <div className="info-banner dark shadow-sm mb-5">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <h1 className="fw-bold mb-3 display-5">Get in Touch</h1>
            <p className="lead opacity-75 mb-0">
              Have a question about trading, business accounts, or just want to say hello?
              Our team is here to help you get the most out of ToyTrade Pakistan.
            </p>
          </div>
          <div className="col-lg-5 d-none d-lg-block text-end">
            <i className="bi bi-envelope-paper-fill" style={{ fontSize: '120px', opacity: '0.2' }}></i>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <div className="contact-card text-center">
            <div className="mb-3 text-primary">
              <i className="bi bi-envelope-fill fs-1"></i>
            </div>
            <h4 className="fw-bold">Email Us</h4>
            <p className="text-muted">For general inquiries and support</p>
            <a href="mailto:admin@topnear.com" className="btn btn-outline-primary rounded-pill px-4">admin@topnear.com</a>
          </div>
        </div>

        <div className="col-md-4">
          <div className="contact-card text-center">
            <div className="mb-3 text-primary">
              <i className="bi bi-chat-heart-fill fs-1"></i>
            </div>
            <h4 className="fw-bold">Feedback</h4>
            <p className="text-muted">Use the in-app feedback feature</p>
            <p className="fw-bold text-primary mb-0">Available in App Settings</p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="contact-card text-center">
            <div className="mb-3 text-primary">
              <i className="bi bi-people-fill fs-1"></i>
            </div>
            <h4 className="fw-bold">Social Media</h4>
            <p className="text-muted">Connect with our community</p>
            <div className="d-flex justify-content-center gap-2">
              <a href="https://facebook.com" className="btn btn-light rounded-circle"><i className="bi bi-facebook"></i></a>
              <a href="https://instagram.com" className="btn btn-light rounded-circle"><i className="bi bi-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 bg-light rounded-4 text-center">
        <h3 className="fw-bold mb-3">Download the App</h3>
        <p className="mb-4 text-muted">The best way to experience ToyTrade and get instant support is through our mobile app.</p>
        <AppLinks className="justify-content-center" />
      </div>
    </div>
  );
}

export default Contact;
